import { DEFAULT_DATE_FORMAT, useDateFormatStore, type DateFormatStyle } from '../lib/dateFormat';
import { useCabinetDateFormat } from './queries/useCabinetSettings';

/**
 * Pose le format de date du cabinet pour `formatAppDate` et le rend.
 * À appeler une fois, dans la mise en page : sa valeur sert de clé pour
 * réafficher la page quand le réglage change.
 */
export function useAppDateFormat(): DateFormatStyle {
  const { data } = useCabinetDateFormat();
  const style = data ?? DEFAULT_DATE_FORMAT;
  // Posé pendant le rendu, avant celui des pages : pas de premier affichage au mauvais format.
  // Personne ne s'abonne à ce store, l'écriture ne relance aucun rendu.
  if (useDateFormatStore.getState().style !== style) {
    useDateFormatStore.setState({ style });
  }
  return style;
}
